import styled from 'particles/themes/styled'
import React from 'react'

import awarenessIllustration from './illustrations/objective-detail-awareness.png'
import trafficIllustration from './illustrations/objective-detail-traffic.png'
import credibilityIllustration from './illustrations/objective-detail-credibility.png'
import appPromotionIllustration from './illustrations/objective-detail-appPromotion.png'
import contentIllustration from './illustrations/objective-detail-content.png'
import { ObjectiveType } from 'state/campaignTemplates'

interface ObjectiveIllustrationsProps {
    type: ObjectiveType
    width?: string
    height?: string
}

const illustrationMap: Record<ObjectiveType, string> = {
    awareness: awarenessIllustration,
    traffic: trafficIllustration,
    credibility: credibilityIllustration,
    appPromotion: appPromotionIllustration,
    content: contentIllustration,
}

const ObjectiveIllustrations: React.FC<ObjectiveIllustrationsProps> = ({ type, width, height }) => {
    return <ImageContainer src={illustrationMap[type]} width={width} height={height} />
}

export default ObjectiveIllustrations

const ImageContainer = styled.img`
    width: ${({ width }) => width || '100%'};
    height: ${({ height }) => height || 'auto'};
`
